import { Leaf, MessageCircle, ShieldCheck, Sparkles } from 'lucide-react'

import { TelegramOrderButton } from '../components/TelegramButton'
import { ButtonLink, Container, Reveal, SectionTitle } from '../components/ui'
import { useI18n } from '../lib/i18n'

const qualities = [
  { icon: Leaf, title: 'feature_natural', body: 'feature_natural_text' },
  { icon: Sparkles, title: 'feature_selected', body: 'feature_selected_text' },
  { icon: ShieldCheck, title: 'feature_quality', body: 'feature_quality_text' },
  { icon: MessageCircle, title: 'feature_service', body: 'feature_service_text' },
]
const stats = [['local_farmers', '12'], ['years_experience', '8'], ['natural_ingredients', '100%']]

export function About() {
  const { t } = useI18n()
  return (
    <Container className="max-w-6xl px-4 pt-24 sm:px-6 sm:pt-28">
      <div className="max-w-3xl">
        <p className="text-[12.5px] font-medium uppercase tracking-[0.16em] text-accent">{t('about_eyebrow')}</p>
        <h1 className="font-display mt-3 text-balance text-[clamp(42px,8vw,68px)] leading-[0.98]">{t('about_title')}</h1>
        <p className="mt-6 max-w-2xl text-pretty text-[16px] leading-relaxed text-muted">{t('about_intro')}</p>
      </div>

      <Reveal className="mt-10 grid gap-3 sm:mt-14 sm:grid-cols-[1.4fr_1fr] sm:gap-4">
        <div className="image-frame aspect-[4/3] overflow-hidden rounded-[28px] bg-surface-2">
          <img src="/images/dokon.jpg" alt={t('about_image_shop')} loading="lazy" className="size-full object-cover" />
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-1 sm:gap-4">
          <div className="image-frame aspect-[4/3] overflow-hidden rounded-[24px] bg-surface-2">
            <img src="/images/anjir.jpg" alt={t('dried_figs')} loading="lazy" className="size-full object-cover" />
          </div>
          <div className="image-frame aspect-[4/3] overflow-hidden rounded-[24px] bg-surface-2">
            <img src="/images/assorti.jpg" alt={t('dried_fruit_mix')} loading="lazy" className="size-full object-cover" />
          </div>
        </div>
      </Reveal>

      <div className="mt-12 grid gap-8 md:mt-16 lg:grid-cols-[1fr_2fr] lg:gap-16">
        <Reveal><p className="font-display text-[30px] leading-[1.08] sm:text-[34px]">“{t('about_quote')}”</p></Reveal>
        <Reveal delay={0.1} className="flex flex-col gap-5 text-[15px] leading-relaxed text-muted">
          <p>{t('about_story_1')}</p>
          <p>{t('about_story_2')}</p>
          <p>{t('about_story_3')}</p>
          <ButtonLink to="/shop" className="mt-2 min-h-12 self-start">{t('shop_now')}</ButtonLink>
        </Reveal>
      </div>

      <section className="py-12 md:py-20">
        <Reveal><SectionTitle eyebrow={t('why_us')} title={t('quality_is_habit')} /></Reveal>
        <div className="mt-8 grid auto-rows-fr gap-4 sm:grid-cols-2 sm:gap-5">
          {qualities.map(({ icon: Icon, title, body }, i) => (
            <Reveal key={title} delay={i * 0.06}>
              <div className="flex h-full gap-4 rounded-[22px] border border-line bg-surface/70 p-6">
                <span className="grid size-11 shrink-0 place-items-center rounded-[13px] bg-forest/10 text-forest"><Icon className="size-5" /></span>
                <div><p className="text-[15px] font-medium">{t(title)}</p><p className="mt-1.5 text-[13.5px] leading-relaxed text-muted">{t(body)}</p></div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <dl className="grid gap-8 border-t border-line py-10 sm:grid-cols-3">
        {stats.map(([key, value]) => <div key={key}><dt className="text-[12.5px] uppercase tracking-[0.14em] text-muted">{t(key)}</dt><dd className="font-display mt-2 text-[46px] leading-none text-forest">{value}</dd></div>)}
      </dl>

      <Reveal className="pb-12 md:pb-20">
        <div className="flex flex-col items-start gap-5 rounded-[28px] bg-surface-2/70 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-9">
          <div><p className="font-display text-[28px] leading-tight sm:text-[32px]">{t('contact_us')}</p><p className="mt-1.5 text-[14px] text-muted">{t('about_cta_text')}</p></div>
          <TelegramOrderButton label={t('contact_us')} size="lg" full className="sm:w-auto" />
        </div>
      </Reveal>
    </Container>
  )
}
